// extracted by mini-css-extract-plugin
export default {"component":"NotFoundView_component__+ud-r","logo":"NotFoundView_logo__tXVov","icon":"NotFoundView_icon__tMtlM","text":"NotFoundView_text__uJ8Dt"};